"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _userLists = _interopRequireDefault(require("@/api/userLists"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _dept = require("@/api/system/dept");

var _vueTreeselect = _interopRequireWildcard(require("@riophae/vue-treeselect"));

require("@riophae/vue-treeselect/dist/vue-treeselect.css");

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {
  id: null,
  type: null,
  depts: null,
  userId: null
};
var _default = {
  name: 'UserLists',
  components: {
    pagination: _Pagination.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    udOperation: _UD.default,
    Treeselect: _vueTreeselect.default
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '归类用户列表',
      url: 'api/userLists',
      idField: 'id',
      sort: 'id,desc',
      crudMethod: _objectSpread({}, _userLists.default)
    });
  },
  data: function data() {
    return {
      permission: {
        add: ['admin', 'userLists:add'],
        edit: ['admin', 'userLists:edit'],
        del: ['admin', 'userLists:del']
      },
      rules: {
        type: [{
          required: true,
          message: '列表类型不能为空',
          trigger: 'blur'
        }],
        depts: [{
          required: true,
          message: '选中部门不能为空',
          trigger: 'blur'
        }]
      },
      menus: [],
      menuIds: [],
      depts: [],
      deptDatas: [],
      // 多选时使用
      queryTypeOptions: [{
        key: 'type',
        display_name: '列表类型'
      }, {
        key: 'userId',
        display_name: '用户编号'
      }]
    };
  },
  methods: (_methods = {}, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeRefresh, function () {
    this.getDepts();
    return true;
  }), (0, _defineProperty2.default)(_methods, "getDepts", function getDepts() {
    var _this = this;

    (0, _dept.getDepts)({
      enabled: true
    }).then(function (res) {
      _this.depts = res.content.map(function (obj) {
        if (obj.hasChildren) {
          obj.children = null;
        }

        return obj;
      });
    });
  }), (0, _defineProperty2.default)(_methods, "getSupDepts", function getSupDepts(depts) {
    var _this2 = this;

    var ids = [];
    depts.forEach(function (dept) {
      ids.push(dept.id);
    });
    (0, _dept.getDeptSuperior)(ids).then(function (res) {
      var date = res.content;

      _this2.buildDepts(date);

      _this2.depts = date;
    });
  }), (0, _defineProperty2.default)(_methods, "buildDepts", function buildDepts(depts) {
    var _this3 = this;

    depts.forEach(function (data) {
      if (data.children) {
        _this3.buildDepts(data.children);
      }

      if (data.hasChildren && !data.children) {
        data.children = null;
      }
    });
  }), (0, _defineProperty2.default)(_methods, "loadDepts", function loadDepts(_ref) {
    var action = _ref.action,
        parentNode = _ref.parentNode,
        callback = _ref.callback;

    if (action === _vueTreeselect.LOAD_CHILDREN_OPTIONS) {
      (0, _dept.getDepts)({
        enabled: true,
        pid: parentNode.id
      }).then(function (res) {
        parentNode.children = res.content.map(function (obj) {
          if (obj.hasChildren) {
            obj.children = null;
          }

          return obj;
        });
        setTimeout(function () {
          callback();
        }, 200);
      });
    }
  }), (0, _defineProperty2.default)(_methods, "changeScope", function changeScope() {
    if (this.form.dataScope === '自定义') {
      this.getDepts();
    }
  }), _methods)
};
exports.default = _default;